import React, { useEffect, useState } from "react";
import error from "../../../assets/Images/icons/alert-tri.svg";
import { LanguageWrapper } from "./style/language";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import edit from "../../../assets/Images/image/edit.png";
import waste from "../../../assets/Images/image/Waste.png";
import { NavLink, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { APP_URLS } from "../../../api/url";
import API from "../../../api/axios";
import { toast } from "react-toastify";
import Pagination from "../../../assets/SharedComponents/Pagination";
import SideTranslate from "../../Translate/components/SideTranslate";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import { getName } from "../../../core/utils/getName/getName";
import { ThreeDots } from "react-loader-spinner";
import RecordCount from "../../../assets/SharedComponents/RecordCount/RecordCount";
import { FaFilterIcon } from "../../../assets/Images/icon";
import { Tooltip } from "@mui/material";

const Language = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const search = useLocation().search;
  const query = new URLSearchParams(search);

  const [data, _data] = useState([]);
  const [countries, setcountries] = useState(JSON.parse(localStorage.getItem("countries")));
  const [languages, setlanguages] = useState(JSON.parse(localStorage.getItem("languages")));

  const [dataDeleted, _dataDeleted] = useState(false);
  const [countValue, _countValue] = useState(searchParams.get('per_page')!==null?searchParams.get('per_page'):"");

  const [filters, _filters] = useState(false);


  const [page, setPage] = useState(searchParams.get('page')!==null?parseInt(searchParams.get('page')):1);
  const [totalPage, _totalPage] = useState(0);
  const [total, _total] = useState(0);
  const [loaded, _loaded] = useState(false);

  const [userAccess,_userAccess] = useState(JSON.parse(localStorage.getItem('permissions')))
  
  let translationAccess = userAccess.find(o=>o.slug ==="translation")

  let navigate = useNavigate();

  useEffect(() => {
    getLanguages();
    _dataDeleted(false);
  }, [dataDeleted, page,countValue]);

  const getLanguages = () => {
    _loaded(true);
    API.get(APP_URLS.ADMIN_LANGUAGES + `?page=${page}&per_page=${countValue}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _data(resp.data.data);
          _totalPage(resp.data.last_page);
          _loaded(false);
          _total(resp.data.total);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          _loaded(false);
        }
      })
      .catch(function (error) {
        _loaded(false);
        const resp = error.response;
        let error_message = "";
        if (resp.data.errors !== undefined) {
          {
            Object.keys(resp.data.errors).map((error, index) => (error_message = resp.data.errors[error][0]));
          }
        } else if (resp.data.data?.error !== undefined) {
          error_message = resp.data.data.error;
        } else if (resp.data?.error !== undefined) {
          error_message = resp.data.error;
        } else {
          error_message = resp.data.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const getLimitedLanguages =() =>{
    API.get(APP_URLS.ADMIN_LANGUAGES+`?limited_data=true`)
    .then(res => {
      const resp = res.data;
      if(resp.success===true){
        let languages = resp.data.items
        localStorage.setItem("languages",JSON.stringify(languages))
      }
      else{
        toast.error(resp.message, {
          position: toast.POSITION.TOP_RIGHT
        })
      }
    })
    .catch(function (error) {  
      const resp = error.response;
      let error_message = '';
      if (resp.data.data !== undefined && resp.data.data !== null) {
        {
          Object.keys(resp.data.data).map(
            (error, index) =>(error_message = resp.data.data[error][0])
          );
        }
      } else if (resp.data.data?.error !== undefined) {
          error_message =  resp.data.data.error;
      } else if(resp.data?.error!== undefined){
          error_message =  resp.data.error
      } else{
          error_message =  resp.data.message
      }
      toast.error(error_message, {
        position: toast.POSITION.TOP_RIGHT
      })
    });
  }

  const getActiveLanguages = () => {
    API.get(APP_URLS.LANGUAGE_LIST)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          let languages = resp.data.languages;
          localStorage.setItem("languages", JSON.stringify(languages));
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        const resp = error.response;
        let error_message = "";
        if (resp.data.data !== undefined && resp.data.data !== null) {
          {
            Object.keys(resp.data.data).map((error, index) => (error_message = resp.data.data[error][0]));
          }
        } else if (resp.data.data?.error !== undefined) {
          error_message = resp.data.data.error;
        } else if (resp.data?.error !== undefined) {
          error_message = resp.data.error;
        } else {
          error_message = resp.data.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const removeAddress = (index) => {
    confirmAlert({
      title: "Confirm to remove",
      message: `Are you sure you want to remove?`,
      closeOnEscape: true,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            API.delete(APP_URLS.DELETE_LANGUAGE + `/${index}`)
              .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                  getActiveLanguages();
                  _dataDeleted(true);
                  toast.success("Language has been deleted successfully.", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                  getLimitedLanguages()
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch(function (error) {
                const resp = error.response;
                let error_message = "";
                if (resp.data.data !== undefined && resp.data.data !== null) {
                  {
                    Object.keys(resp.data.data).map((error, index) => (error_message = resp.data.data[error][0]));
                  }
                } else if (resp.data.data?.error !== undefined) {
                  error_message = resp.data.data.error;
                } else if (resp.data?.error !== undefined) {
                  error_message = resp.data.error;
                } else {
                  error_message = resp.data.message;
                }
                toast.error(error_message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              });
          },
        },
        {
          label: "No",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
    });
  };

  const handleSearchChange = (searchValue) => {
    _countValue(searchValue);
    if (searchValue !== "") {
      _totalPage(0)
      setPage(1);
    }
  };

  const clearFilter = () => {
    _filters(true)
    handleSearchChange('');
    if (countValue !== '') {
      _totalPage(0)
      setPage(1);
    }
    for(var value of query.keys()) {
      const param = searchParams.get(value);
      if (param) {
        searchParams.delete(value);
        setSearchParams(searchParams);
      }
    }
  };

  return (
    <>
      <LanguageWrapper>
        <div className="row">
          <div className="col-lg-2 col-md-3 col-sm-4 mt-3">
            <h4 className="translation text-center mb-3">TRANSLATION</h4>
            <SideTranslate />
          </div>
          <div className="col-lg-10 col-md-9 col-sm-8 mt-2">
            <div className="headerContainer">
              <h1>LANGUAGE</h1>
            </div>
            <div className="row">
            <div className="d-flex justify-content-between add-info flex-wrap">
              <div className="add-depertment d-flex justify-content-end mb-2">
                {translationAccess.permissions.find((o) => o.slug === "add") ? (
                  <div className="actionContainer">
                    <NavLink to="/translation/create-language">
                      <button className="btn">+ Add</button>
                    </NavLink>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="d-flex justify-content-end mb-2 gap-2 flex-wrap align-items-center gap-2">
                <RecordCount
                  onSearchClick={(search) => handleSearchChange(search)}
                  id="pageCount"
                  val={countValue}
                  filters={filters}
                  _filters={_filters} />
                <Tooltip title="Clear Filter" placement="bottom">
                  <FaFilterIcon className="filter-icon" role="button" onClick={clearFilter} />
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between info-wrap">
            <div className="justify-content-end mt-1 me-2">
                <span className='text-start'>Total Records : <b>{total}</b></span>
            </div>
          </div>
          
              <div className="tableContainer">
              <table className="auctionTable">
                <thead className="tableHead">
                  <tr className="table-row">
                    <th>ID</th>
                    <th>Language Code</th>
                    <th>Language Name</th>
                    <th>Status</th>
                    <th>Updated by</th>
                    <th>Created by</th>
                    {translationAccess.permissions.find((o) => o.slug === "update") || translationAccess.permissions.find((o) => o.slug === "delete") ? <th>Action</th> : ""}
                  </tr>
                </thead>
                {
              loaded ? 
              <div className='d-flex justify-content-center three-dot'>              
              <ThreeDots 
                height="150" 
                width="150" 
                radius="9"
                color="#637df4" 
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
          </div>
              :
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => {
                      let flag = countries.find((o) => o.id === item.country_id);
                      let createdBy = getName(item.create_activity_log, item.update_activity_log);
                      let upadtedBy = getName(item.update_activity_log, item.create_activity_log);

                      return (
                        <tr className="table-row" key={index}>
                          <td>{item.id}</td>
                          <td className="tableHead-2">
                            {Object.keys(item.name).map((val, index) => {
                              let country_id;
                              let flag;
                              let countryValues = languages.find((o) => o.code === val);
                              if (countryValues) {
                                country_id = countryValues.country_id;
                                flag = countries.find((o) => o.id === country_id)?.flag_thumbnail;
                              }
                              return (
                                <div key={index} className="languageSelected d-flex gap-2">
                                  {countryValues ? (
                                    <>
                                      <img src={flag} alt="" title={countryValues?.name}/>
                                      <span className="flagName">{val}</span>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              );
                            })}
                          </td>
                          <td className="tableHead-3">
                            {Object.keys(item.name).map((val, index) => {
                              let countryValues = languages.find((o) => o.code === val);
                              return item.name[val] !== null && item.name[val] !== "" ? (
                                <span key={index} className="nameTranslated">
                                  {countryValues ? item.name[val] : ""}
                                </span>
                              ) : (
                                <span key={index} className="nameTranslated">
                                  <img src={error} alt="" className="warningIcon" />
                                </span>
                              );
                            })}
                          </td>
                          <td>{item.status === 1 ? <span className="status status-active" title="Active"></span> : <span className="status status-end" title="Inactive"></span>}</td>
                          <td>{upadtedBy !== "" && upadtedBy !== undefined ? upadtedBy.charAt(0).toUpperCase() + upadtedBy.slice(1) : "-"}</td>
                          <td>{createdBy !== "" && createdBy !== undefined ? createdBy.charAt(0).toUpperCase() + createdBy.slice(1) : "-"}</td>
                          {translationAccess.permissions.find((o) => o.slug === "delete") || translationAccess.permissions.find((o) => o.slug === "update") ? (
                            <td className="action">
                              {translationAccess.permissions.find((o) => o.slug === "update") ? (
                                <button className="me-2" onClick={() => navigate(`/translation/edit-language/${item.id}?`+(countValue!==""?"per_page="+countValue+"&":"")+(page!==1?"page="+page:""))}>
                                  <img src={edit} alt="f" />
                                </button>
                              ) : (
                                ""
                              )}
                              {translationAccess.permissions.find((o) => o.slug === "delete") && item.name !== "English" && item.name !== "French" ? (
                                <button onClick={() => removeAddress(item.id)}>
                                  <img src={waste} alt="f" />
                                </button>
                              ) : (
                                ""
                              )}
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>
            }
              </table>
            </div>
            <div>
              {totalPage > 1 ? <Pagination totalPages={totalPage} page={page} key={totalPage} onPageClick={(page) => setPage(page + 1)} /> : ""}
            </div>
          </div>
        </div>
      </LanguageWrapper>
    </>
  );
};

export default Language;
